import { useRolodexFileLS, useRolodexSignedURLs } from 'features/rolodex'
import { useEffect, useState } from 'react'

export const usePdfPreview = (
  entryId: string,
  fileType: string,
  setShowPdfPreviewer: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [pdfURL, setPdfURL] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const { fileRefs } = useRolodexFileLS({
    entry_id: entryId,
    path: '**',
  })

  const { url } = useRolodexSignedURLs(fileRefs)

  useEffect(() => {
    if (!url) {
      return
    }

    setIsLoading(true)
    setShowPdfPreviewer(true)

    if (fileType.toLowerCase() === 'pdf') {
      // Use the signed URL directly so the browser can stream the PDF via range requests
      setPdfURL(url)
    } else {
      setPdfURL(null)
    }

    setIsLoading(false)
  }, [url, fileType, setShowPdfPreviewer])

  return { pdfURL, isLoading }
}
